export default {
  title: 'Détails de la commande',
};
